import Vue from 'vue'
import axios from 'axios';

Vue.prototype.$cidadaoRegistrar = async (cidadao) =>{
  try { 
    //console.log(cidadao);
    let res = await axios.post('cidadaos',{
        nome:cidadao['nome'],
        email:cidadao['email'],
        senha:cidadao['senha'],
        tipo:cidadao['tipo'],
        cpf:cidadao['cpf'],
        cnpj:cidadao['cnpj'],
        telefone:cidadao['telefone'],
        celular:cidadao['celular'],
        cep:cidadao['cep'],
        rua:cidadao['rua'],
        numero:cidadao['numero'],
        bairro:cidadao['bairro'],
        complemento:cidadao['complemento'],
        estado: cidadao['estado']
    });
    return res.data;
  } catch (e) {
    throw e;
    //console.log(e.message);
  } 
}

